import type {Module} from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import type {RootState} from '@/store'
import type {Company} from '@/api/modules/companies'

export interface CompanyState {
  data: Array<Company>
  loading: boolean
}

export const defaultState = (): CompanyState => {
  return {
    data: [],
    loading: false,
  }
}

const namespaced = true

const Companies: Module<CompanyState, RootState> = {
  namespaced,
  state: defaultState(),
  getters,
  actions,
  mutations,
}

export default Companies
